import { AlkLogger } from '@alk/core';
import { ISessionDisposable } from '../../interfaces';

export function stopDisposableService(srv: ISessionDisposable): void {
    if (typeof srv.stop !== 'function') {
        AlkLogger.warn(`[session-lifecycle.utils#stopDisposableService] ${ srv } isn't stoppable !`);

        return;
    }

    srv.stop();
}
